/**
 * フォームの項目に値を挿入する
 *
 * @param id 項目のid
 * @param value 値
 * @param force 強制フラグ
 */
export function fillForm(
  id: string,
  value: null | undefined | string,
  force: boolean
): void {
  const el: null | HTMLInputElement | HTMLSelectElement =
    document.querySelector(
      '[data-drupal-selector="' + id.replace(/^#/, '') + '"]'
    )
  if (el) {
    if (el instanceof HTMLSelectElement) {
      // セレクトボックスで選択肢に一致する値が存在しない場合、値の挿入は行わない
      const hasOption = Array.from(el.options).find((el) => el.value === value)
      if (!hasOption) {
        return
      }
    }

    // 強制フラグが無い場合、値が空の場合のみ挿入する
    if (force || (el.value !== null && el.value.trim().length === 0)) {
      el.value = value ?? ''
    }
  }
}

/**
 * フォームの項目に値を挿入する（チェックボックス）
 *
 * @param id 項目のid
 * @param value 値
 * @param force 強制フラグ
 * @param dispatchEvent dispatchEvent発行フラグ
 */
export function checkForm(
  id: string,
  value: boolean,
  force: boolean,
  dispatchEvent: boolean
): void {
  const el: null | HTMLInputElement = document.querySelector(id)
  if (el) {
    if (force || el.checked !== null) {
      el.checked = value
    }
    // Drupalで値が変化したことを検知するためにイベント発行
    if (dispatchEvent) {
      const event = document.createEvent('Event')
      event.initEvent('change', false, true)
      el.dispatchEvent(event)
    }
  }
}

/**
 * アコーディオンを開く
 */
export function openAccordion(): void {
  // 一度開いたらフィールドのイベントリスナーは解除
  const elList: null | NodeList = document.querySelectorAll(
    '.js-form-first-item'
  )
  elList.forEach((e) => {
    e.removeEventListener('focus', openAccordion)
  })

  const active = 'is-active'
  const el: null | HTMLElement = document.querySelector('#edit-accordion-text')
  // 開いているときは何も行わない
  if (!el || el.classList.contains(active)) {
    return
  }

  // アクティブクラスを付け替えてアコーディオンを開く
  el.classList.toggle(active)
  const container: null | HTMLElement =
    document.querySelector('.c-textAccordion')
  const targetList: string[] = [
    '.c-textAccordion__buttonArea--close',
    '.c-textAccordion__buttonArea--open'
  ]
  if (container) {
    targetList.forEach((target) => {
      const targetEl: null | HTMLElement = container.querySelector(target)
      if (targetEl) {
        targetEl.classList.toggle(active)
        const children: string[] = [
          '.c-textAccordion__button--more',
          '.c-textAccordion__button--less',
          '.icon-sh-arrowBottom-small',
          '.icon-sh-arrowTop-small'
        ]
        children.forEach((child) => {
          const childEl: null | HTMLElement = targetEl.querySelector(child)
          if (childEl) {
            childEl.classList.toggle(active)
          }
        })
      }
    })
  }
}

/**
 * Webformの最初の項目にアコーディオンを開くイベントを追加
 *
 */
export function addOpenAccordionEvent(): void {
  // 初期表示の項目にフォーカスされたときアコーディオンを開く（初回のみ）
  const elList: null | NodeList = document.querySelectorAll(
    '.js-form-first-item'
  )
  if (elList) {
    elList.forEach((el) => {
      el.addEventListener('focus', openAccordion)
    })
  }
}
